import { Dispatch } from "@reduxjs/toolkit";
import { ThunkActionType } from "../store";
import { ReviewRun } from "../../types/reviewTypes";
import { fetchWrapper } from "./fetchWrapper";

export type ReviewActionTypes =
  | SetReviewLoading
  | SetReviewHistory
  | SetNewReviewRun;
export interface SetReviewLoading {
  type: "SET_REVIEW_LOADING";
  payload: {
    loading: boolean;
  };
}
export interface SetReviewHistory {
  type: "SET_REVIEW_HISTORY";
  payload: {
    history: ReviewRun[];
  };
}
export interface SetNewReviewRun {
  type: "SET_REVIEW_RUN";
  payload: {
    run: ReviewRun;
    action: "CREATE" | "DELETE";
  };
}
export const setReviewLoading = (loading: boolean): SetReviewLoading => ({
  type: "SET_REVIEW_LOADING",
  payload: {
    loading,
  },
});
export const setReviewHistory = (history: ReviewRun[]): SetReviewHistory => ({
  type: "SET_REVIEW_HISTORY",
  payload: {
    history,
  },
});

export const getReviewRuns = (): ThunkActionType => {
  return async (dispatch: Dispatch<ReviewActionTypes>) => {
    dispatch(setReviewLoading(true));
    const result = await fetchWrapper(dispatch, "GET", "review/getall");
    dispatch(setReviewLoading(false));
    if (result.returnCode === 0) {
      dispatch({
        type: "SET_REVIEW_HISTORY",
        payload: {
          history: result.responseMessage.runs,
        },
      });
    }
  };
};

export const addReviewRun = (run: ReviewRun): ThunkActionType => {
  return async (dispatch: Dispatch<ReviewActionTypes>) => {
    dispatch(setReviewLoading(true));
    const result = await fetchWrapper(dispatch, "PUT", "review/addrun", {
      run,
    });
    dispatch(setReviewLoading(false));
    if (result.returnCode === 0) {
      dispatch({
        type: "SET_REVIEW_RUN",
        payload: {
          run: result.responseMessage.run,
          action: "CREATE",
        },
      });
    }
  };
};

export const deleteReviewRun = (run: ReviewRun): ThunkActionType => {
  return async (dispatch: Dispatch<ReviewActionTypes>) => {
    dispatch(setReviewLoading(true));
    const result = await fetchWrapper(dispatch, "DELETE", "review/removerun", {
      runId: run.runId,
    });
    dispatch(setReviewLoading(false));
    if (result.returnCode === 0) {
      dispatch({
        type: "SET_REVIEW_RUN",
        payload: {
          run,
          action: "DELETE",
        },
      });
    }
  };
};
